/**
 * The watch bell (DESIGN-CHANGELOG 2026-09-03; `gt-logic.js:523-526`
 * `BELL_SOLID` / `BELL_HOLLOW`). A drawn 9×9, never a font glyph: SOLID when
 * something is armed, HOLLOW when nothing is — the same footprint, so a chip
 * never reflows when it flips. Off is an outline: visible, never hidden.
 */

const SOLID = 'M3 0h3v1H3zM2 1h5v2H2zM1 3h7v3H1zM0 6h9v1H0zM3 8h3v1H3z';
const HOLLOW = 'M3 0h3v1H3zM2 1h1v2H2zM6 1h1v2H6zM1 3h1v3H1zM7 3h1v3H7zM0 6h9v1H0zM3 8h3v1H3z';

export function Bell({ on, size, color }: { on: boolean; size: number; color: string }): JSX.Element {
  return (
    <svg viewBox="0 0 9 9" style={{ width: size, height: size, display: 'block', flex: 'none', color }} shapeRendering="crispEdges" aria-hidden="true">
      <path d={on ? SOLID : HOLLOW} fill="currentColor" />
    </svg>
  );
}
